// Copy of components/datePicker/DatePicker.selectors.js on its own Redux slice for the Payments - Beta tab.
import {
  getCalendarDate,
  isCalendarIntervalValid,
  getOppositeToken,
  isDateEmpty,
} from "@/components/datePicker/Search.dates.util";

const getState = (state) => state.transactionSearchDatePickerV2Beta;

export const criteriaState = (state) => getState(state).criteria;
export const datesState = (state) => getState(state).dates;
export const calendarStateDates = (state) => datesState(state).calendar;
export const visibleMonth = (state) => datesState(state).visibleMonth;
export const anchorDate = (state) => calendarStateDates(state).startDate;
export const isCriteriaOpen = (state) => criteriaState(state).isCriteriaOpen;
export const isDatesOpen = (state) => datesState(state).isOpen;
export const openedCriteriaDropdown = (state) => criteriaState(state).openedDropdown;
export const openedCriteriaDropdownType = (state) =>
  openedCriteriaDropdown(state).type;

export const isOpen = (state) => isCriteriaOpen(state) || isDatesOpen(state);
export const isAnyCriteriaDropdownOpen = (state) =>
  !!openedCriteriaDropdownType(state);

export const isValid = (state) =>
  criteriaState(state).criteria.every((c) => !c.error);

export const getCalendarDates = (
  transactionSearchDatePickerV2BetaState,
  { token, date }
) => {
  const _date = getCalendarDate(date);
  const _dates = transactionSearchDatePickerV2BetaState?.dates?.calendar;
  const opposite = getOppositeToken(token);
  const newDate = _date || (isDateEmpty(_date) ? null : _dates[token]);
  const dates = {
    [opposite]: _dates[opposite],
    [token]: newDate,
  };
  if (!isCalendarIntervalValid(dates)) {
    dates[opposite] = null;
  }
  return { dates, token, date };
};
export const getTransactionSearchStartDate = (state) =>
  getState(state).dates.calendar.startDate;
export const getTransactionSearchEndDate = (state) =>
  getState(state).dates.calendar.endDate;
export const getFocusedInput = (state) => getState(state).dates.focusedInput;
